<div>
  <p class="spacing--none ag-cell-fund-name" *ngIf="isSoftLaunch">
    <ng-container *ngTemplateOutlet="fundNameContent"></ng-container>
  </p>
  <p class="spacing--none ag-cell-fund-name" *ngIf="!isSoftLaunch">
    <eds-link-item
      class="ag-cell-frk--link"
      [href]="fundLink"
      eventId="linkOrButtonClick"
    >
      <ng-container *ngTemplateOutlet="fundNameContent"></ng-container>
    </eds-link-item>
  </p>
  <ng-container *ngIf="showSalesCharges">
    <p class="spacing--none small">
      <span>
        {{ "products.sales-charges" | translate }} :
        {{ "products.max-initial-charge" | translate }}
        - {{ maxIntialSalesCharge }} | {{ "products.cdsc" | translate }} -
        {{ cdsc }}
      </span>
    </p>
  </ng-container>
  <ng-container *ngIf="showPerformanceAndMaintananceCharges">
    <p class="spacing--none small">
      <span>
        {{ "products.maintanance-charges" | translate }} :
        {{ "products.max-performance-charge" | translate }}
        - {{ maintananceCharge }} | {{ performanceCharge }}
      </span>
    </p>
  </ng-container>
  <div *ngIf="ppssMessage">
    <ng-container *ngIf="!ppssTooltip">
      <eds-notifications
        edsPadding
        edsPaddingLeft="xs"
        [title]="ppssMessage"
        [notificationType]="notificationType"
        [inline]="true"
      ></eds-notifications>
    </ng-container>
    <ng-container *ngIf="ppssTooltip">
      <eds-notifications
        edsPadding
        edsPaddingLeft="xs"
        [title]="ppssMessage"
        [notificationType]="notificationType"
        [inline]="true"
        edsTooltip
        [analyticsName]="ppssMessage"
        tooltipBehavior="fixed"
        [tooltipPositionDefault]="showTooltipAtTop ? 'top' : 'bottom'"
        [tooltipContent]="ppssTooltip"
      ></eds-notifications>
    </ng-container>
  </div>
</div>

<ng-template #fundNameContent>
  {{ fundDetail?.fundName }}
  <span *ngIf="fundDetail?.suffix">
    -
    <strong *ngIf="fundDetail?.highlightSuffix">
      {{ fundDetail?.suffix }}
    </strong>
    <span *ngIf="!fundDetail?.highlightSuffix">
      {{ fundDetail?.suffix }}
    </span>
  </span>
  <span *ngIf="fundDetail?.secondSuffix">
    ({{ fundDetail?.secondSuffix }})
  </span>
</ng-template>
